import { useEffect, useMemo, useState } from "react"
import CustomTable from '../../components-legacy/CustomTable.jsx'
import { server } from "../chat/Server.js"

export default function StrategyResultsOrders({ strId, backtest }) {
    const [data, setData] = useState(null)
    const [error, setError] = useState(null)

    useEffect(() => {
        if (backtest.processingStatus !== 'completed') {
            setData(null)
            return
        }
        server.api('strategy/backtest/results', { strId, backtestId: backtest.backtestId, section: 'orders' }).then(res => {
            setData(JSON.parse(res))
        }).catch(() => {
            setError('Error retrieving backtest orders')

        })
    }, [strId, backtest])

    const ordersTableColumns = useMemo(() => [
        {
            accessorKey: "order",
            header: () => "Id",
            cell: info => info.getValue(),
            enableSorting: true,
            sortingFn: 'alphanumeric',
        },
        {
            accessorKey: "openTime",
            header: () => "Open Time",
            cell: info => info.getValue()
        },
        {
            accessorKey: "symbol",
            header: () => "Symbol",
            cell: info => info.getValue()
        },
        {
            accessorKey: "type",
            header: () => "Type",
            cell: info => info.getValue()
        },
        {
            accessorKey: "volume",
            header: () => "Volume",
            cell: info => info.getValue()
        },
        {
            accessorKey: "price",
            header: () => "Price",
            cell: info => info.getValue()
        },
        {
            accessorKey: "stopLoss",
            header: () => "Stop Loss",
            cell: info => info.getValue()
        },
        {
            accessorKey: "takeProfit",
            header: () => "Take Profit",
            cell: info => info.getValue()
        },
        {
            accessorKey: "time",
            header: () => "Time",
            cell: info => info.getValue()
        },
        {
            accessorKey: "state",
            header: () => "State",
            cell: info => info.getValue()
        },
        {
            accessorKey: "comment",
            header: () => "Comment",
            cell: info => info.getValue()
        },
    ], [])

    const ordersTableData = data ? data.map((item) => {
        return {
            order: item.Order,
            openTime: item['Open Time'],
            symbol: item.Symbol,
            type: item.Type,
            volume: item.Volume,
            price: item.Price,
            stopLoss: item['S / L'],
            takeProfit: item['T / P'],
            time: item.Time,
            state: item.State,
            comment: item.Comment
        }
    }) : []

    if (backtest.processingStatus === 'error') {
        return null
    }

    if (backtest.processingStatus === 'processing') {
        return <div className="text-body text-muted-foreground">In Progress...</div>
    }

    if (error) {
        return (
            <section className="p-6 rounded-md min-w-[320px] border border-border bg-card text-foreground">
                <div className="msgError py-2 px-4 rounded-md border border-danger-dim bg-danger-dim text-danger text-body">
                    {error}
                </div>
            </section>
        )
    }

    return (
        <section style={{ overflowX: 'auto' }}>
            <CustomTable
                data={ordersTableData}
                columns={ordersTableColumns}
                classlist={'strategies horizontal-border'}
                defaultSortColumn="order"
                sortByDesc={false}
            />
        </section>
    )
}
